<div class="space-y-sm" *transloco="let t">
  <div>
    <cft-sorting-bar>
      @if (sortingOptions$ | async; as options) {
        <cft-sorting [options]="options" (sortingChanged)="sort($event)"></cft-sorting>
      }
    </cft-sorting-bar>
  </div>
  @if (industries?.length) {
    <div>
      @for (i of industries; track i) {
        <div class="space-y-lg border-b border-grey-300 pt-xl pb-2xl last:border-none" [title]="i.label">
          <div class="flex items-center justify-between">
            <h3 class="heading-lg">{{ i.label }}</h3>
            <a [routerLink]="getIndustryLink(i)" class="btn flex gap-sm btn-ghost">
              {{ t('proDirectoryPage.industry.moreButton') }}
              <fa-icon [icon]="chevronRight"></fa-icon>
            </a>
          </div>
          <div class="grid grid-cols-1 gap-x-2xl gap-y-md pr-lg md:grid-cols-2 lg:grid-cols-3">
            @for (o of i.offerings; track o) {
              <cft-list-element [link]="getOfferingLink(o.id, o.slug)" [label]="o.label"> </cft-list-element>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <bgo-industries-and-offerings-skeleton></bgo-industries-and-offerings-skeleton>
  }
</div>
